const Filter = ({ setParPage, setCurrentPage }) => {
  return (
    <div className="flex justify-between items-center">
      <select
        onChange={(e) => {
          setParPage(parseInt(e.target.value));
          setCurrentPage(1);
        }}
        className="px-4 py-2 focus:border-slate-500 outline-none border rounded-md text-slate-600 cursor-pointer"
      >
        <option value="5">5</option>
        <option value="10">10</option>
        <option value="20">20</option>
      </select>
    </div>
  );
};

export default Filter;
